// Front-end only — no back-end counterpart.

export type CarouselDirection = 'next' | 'prev'

export const CarouselDirection = {
  NEXT: 'next',
  PREV: 'prev'
} satisfies Record<string, CarouselDirection>

export const CarouselDirectionValues: readonly CarouselDirection[] =
  Object.values(CarouselDirection)
